module.exports = __webpack_public_path__ + "static/media/dansen.00a3c46d.png";